import React, { Component } from "react";

export class NotificationPopup extends Component {
  constructor(props) {
    super(props);
   
  }

  render() {
    const alertType = this.props.type === 'error' ? 'alert-danger' : 'alert-success';
    const jsx = this.props.isPopupOpen ? (
      <div className={`alert ${alertType} d-0`} role="alert">
        <strong>{this.props.message}</strong>
      </div>
    ) : (
      <div />
    );
      return jsx;
  }

}
